import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 50px 30px;
  box-sizing: border-box;
  position: relative;
`

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${({theme}) => theme.palette[850]};
  margin: 0 0 20px 0;
`

export const ActionsBar = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`

export const GroupCard = styled.div`
  background: ${({theme}) => theme.palette[200]};
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
`

export const GroupHeader = styled.div<{expanded?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s;
  &:hover {
    background: ${({theme}) => theme.palette[300]};
  }
`

export const GroupLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`

export const GroupName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({theme}) => theme.palette[850]};
`

export const GroupDescription = styled.span`
  font-size: 14px;
  color: ${({theme}) => theme.palette[600]};
`

export const GroupActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const ActionIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s;
  &:hover {
    background: ${({theme}) => theme.palette[400]};
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    &:hover {
      background: transparent;
    }
  }
  img {
    width: 16px;
    height: 16px;
  }
`

export const ChevronIcon = styled.img<{expanded?: boolean}>`
  width: 16px;
  height: 16px;
  transition: transform 0.2s;
  transform: ${({expanded}) => expanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`

export const ProductsTable = styled.div`
  border-top: 1px solid ${({theme}) => theme.palette[300]};
`

export const ProductRow = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 20px 10px 50px;
  border-bottom: 1px solid ${({theme}) => theme.palette[300]};
  transition: background-color 0.15s;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: ${({theme}) => theme.palette[100]};
  }
`

export const ProductCell = styled.div<{flex?: string; clickable?: boolean}>`
  flex: ${({flex}) => flex || '1'};
  font-size: 14px;
  color: ${({theme}) => theme.palette[850]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: ${({clickable}) => clickable ? 'pointer' : 'default'};
  ${({clickable, theme}) => clickable && `
    color: ${theme.primary[600] || theme.primary};
    &:hover {
      text-decoration: underline;
    }
  `}
`

export const ProductHeaderRow = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 20px 8px 50px;
  border-bottom: 1px solid ${({theme}) => theme.palette[300]};
  background: ${({theme}) => theme.palette[200]};
`

export const ProductHeaderCell = styled.div<{flex?: string}>`
  flex: ${({flex}) => flex || '1'};
  font-size: 12px;
  font-weight: 600;
  color: ${({theme}) => theme.palette[600]};
  text-transform: uppercase;
`

export const EmptyGroup = styled.div`
  padding: 12px 20px 12px 50px;
  font-size: 14px;
  color: ${({theme}) => theme.palette[600]};
  font-style: italic;
`

export const ProductCount = styled.span`
  font-size: 12px;
  color: ${({theme}) => theme.palette[600]};
  margin-left: 4px;
`
